import React from 'react';
import { createPortalDomNode } from "../helpers";
var ModalContextValue = /** @class */ (function () {
    function ModalContextValue(config) {
        var _this = this;
        this.config = config;
        this.stack = [];
        this.portalDomNode = null;
        this.listeners = [];
        this.getPortalDomNode = function () {
            if (!_this.portalDomNode) {
                _this.portalDomNode = createPortalDomNode();
            }
            return _this.portalDomNode;
        };
        this.addToStack = function (el) {
            _this.stack.push(el);
        };
        this.removeFromStack = function (el) {
            _this.stack = _this.stack.filter(function (i) { return i !== el; });
        };
        this.getLastFromStack = function () {
            if (_this.stack.length > 0) {
                return _this.stack[_this.stack.length - 1];
            }
            return null;
        };
        this.getPrevFromStack = function () {
            if (_this.stack.length > 1) {
                return _this.stack[_this.stack.length - 2];
            }
            return null;
        };
        this.addListener = function (cb) {
            _this.listeners.push(cb);
            return function () {
                _this.listeners = _this.listeners.filter(function (c) { return c !== cb; });
            };
        };
        this.notify = function () {
            _this.listeners.forEach(function (cb) { return cb(); });
        };
    }
    Object.defineProperty(ModalContextValue.prototype, "mainContentId", {
        get: function () {
            return this.config.mainContentId;
        },
        enumerable: true,
        configurable: true
    });
    return ModalContextValue;
}());
export { ModalContextValue };
export var ModalContext = React.createContext(new ModalContextValue({ mainContentId: 'main-container' }));
//# sourceMappingURL=context.js.map